<template>
    <b-modal class="my-schedule-modal"
              ref="my-schedule-modal"
             :id="tableType"
             :size="size"
             @ok="handleOk(tableType)">
      <template #modal-header>
        <h5>{{ table.toUpperCase() }}</h5>
        <!-- 닫기 버튼 마크업 추가 -->
        <button type="button"
                class="btn-popup-close"
                @click="hideMyScheduleModal"></button>
      </template>
      <modal-table :tableType="table"
                   :ref="tableType"
                   :selectType="selectType"
                   :selectedValues="selectedValues"
                   :keyword="keyword"
                   :notForShowValues="notForShowValues"
                   :list="list"
                   @set-result="setResult"></modal-table>
      <template #modal-footer="{ ok, cancel }">
        <b-button variant="primary"
                  @click="ok()">OK
        </b-button>
        <b-button variant="secondary"
                  @click="cancel()">Cancel
        </b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import modalTable from '@/components/chatter/MyScheduleModalTable.vue';
  
  export default {
    props: {
      tableType: String,
      selectType: String,
      selectedValues: Array,
      notForShowValues: Array,
      list: null,
    },
    data() {
      return {
        keyword: '',
      }
    },
    components: { modalTable },
    methods: {
      reload() {
        this.$refs[this.tableType].retrieveMyScheduleList();
      },
      openModal(ref) {
        this.$bvModal.show(ref);
      },
      closeModal() {
        this.$bvModal.close(this.tableType);
      },
      handleOk(table) {
        this.$refs[table].returnSelectedList();
      },
      setResult(selectedResult, list) {
        this.$emit("set-result", selectedResult, list);
      },
      hideMyScheduleModal(){
        this.$refs['my-schedule-modal'].hide();
      }
    },
    computed: {
      table() {
        switch (this.tableType) {
          case 'subordinateToTable':
            return "mySchedule"
          case 'relatedToTable':
            return "mySchedule"
          default:
            return '';
        }
      },
      size() {
        switch (this.tableType) {
          case 'subordinateToTable':
            return "lg"
          case 'relatedToTable':
            return "lg"
          default:
            return '';
        }
      }
    },
  }
  </script>
  
  <style scoped>
  .modal-dialog .modal-content footer.modal-footer {
      display: flex !important;
      justify-content: flex-start !important;
      align-items: center !important;
  }
  
  .modal-body {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
  
  }
  
  #my-schedule-Modal {
      height: 400px;
      margin: 0px;
  }
  
  .btn-popup-close {
      display: block;
      width: 30px;
      height: 30px;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat transparent;
      border: none;
  }
  
  .modal-body .input-group {
      margin-bottom: 2rem;
      padding-right: 16px;
  }
  
  .modal-body .input-group > .form-control {
      padding: 0.533rem 0.8rem 0.533rem 1.066rem;
      height: 2.666rem !important;
      border-radius: 10px;
      border: 1px solid #E7E7EE;
      background-color: #F6F6FA;
      font-family: 'NanumGothic';
      color: #2E2E38;
      font-size: 16px;
      font-weight: 400;
      line-height: 150% !important;
  }
  </style>